import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { useMemo, useCallback } from 'react';
import { ArrowLeft, ArrowRight } from '@indeed/ifl-icons';
import { usePageLinkProps } from './hooks/usePageLinkProps.js';
import { usePaginationContext } from './hooks/usePaginationContext.js';
import { PREV_LABEL_DEFAULT, NEXT_LABEL_DEFAULT } from './defaultStrings.js';
import { jsx } from '@emotion/react';
import { ButtonLink } from '../ButtonLink/ButtonLink.js';
import { Button } from '../Button/Button.js';
import '../LinkProvider/LinkProvider.js';
import './PaginationContext.js';
import '@indeed/ifl-css';
import '../Button/context.js';
import '../IndeedThemeProvider/hooks/useColorMode.js';
import '../IndeedThemeProvider/hooks/useColorModeAttribute.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../IconWrapper/IconWrapper.js';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Spinner/Spinner.js';
import '@indeed/ihl-use-id';

const baseIconProps = {
  "aria-hidden": true,
  useDirection: true
};
const PaginationArrowButton = _ref => {
  let {
    direction,
    mobile,
    onClick,
    children
  } = _ref;
  const {
    activePage,
    totalPages,
    setPageLinkProps,
    nextAriaLabel,
    prevAriaLabel,
    handleNextClick,
    handlePrevClick
  } = usePaginationContext() || {};
  const ariaLabel = direction === "left" ? prevAriaLabel : nextAriaLabel;
  const defaultLabel = direction === "left" ? PREV_LABEL_DEFAULT : NEXT_LABEL_DEFAULT;
  const icon = useMemo(() => {
    if (direction === "left") {
      return jsx(ArrowLeft, _extends({}, baseIconProps, {
        color: "currentColor"
      }));
    }
    return jsx(ArrowRight, _extends({}, baseIconProps, {
      color: "currentColor"
    }));
  }, [direction]);
  const buttonProps = useMemo(() => ({
    size: "sm",
    variant: "tertiary",
    iconOnly: mobile,
    iconBefore: direction === "left" && !mobile ? icon : undefined,
    iconAfter: direction === "right" && !mobile ? icon : undefined,
    children: mobile ? icon : children,
    ["aria-label"]: ariaLabel === undefined && mobile ? defaultLabel : ariaLabel,
    sx: {
      color: "foreground.action.strong",
      ":hover:not([aria-disabled='true'])": {
        color: "foreground.action.strong.hover"
      },
      ":active:not([aria-disabled='true'])": {
        color: "foreground.action.strong.active"
      }
    }
  }), [children, direction, icon, mobile, ariaLabel, defaultLabel]);
  const disabled = direction === "left" ? activePage === 1 : activePage !== undefined && activePage === totalPages;
  const handleButtonClick = useCallback(() => {
    const nextPrevHandler = direction === "left" ? handlePrevClick : handleNextClick;
    const willBecomeDisabled = direction === "left" ? activePage === 2 : !!(totalPages && activePage === totalPages - 1);
    onClick(willBecomeDisabled);
    if (nextPrevHandler) {
      nextPrevHandler();
    }
  }, [activePage, totalPages, direction, handleNextClick, handlePrevClick, onClick]);
  const pageLinkProps = usePageLinkProps({
    pageNumber: activePage ? activePage + (direction === "left" ? -1 : 1) : null,
    onClick: handleButtonClick
  });
  return setPageLinkProps && activePage && !disabled ? jsx(ButtonLink, _extends({}, pageLinkProps, buttonProps)) : jsx(Button, _extends({
    onClick: handleButtonClick,
    disabled: disabled
  }, buttonProps));
};

export { PaginationArrowButton };
